import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyMaintenance: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-maintenance", jiraSpaEntry: "async-jira-eoc-maintenance" */ '@jira/eoc__maintenance/src/index.tsx'
		),
);

export const MaintenanceComponent = (): React.JSX.Element => (
	<LazyPage Page={LazyMaintenance} pageId="async-jira-eoc-maintenance" shouldShowSpinner={false} />
);
